import {
  GET_BOOKING_LIST_ERROR,
  GET_BOOKING_LIST,
  BOOKING_LIST_LOADING,
  GET_BOOKING_BY_ID_LOADING,
  GET_BOOKING_BY_ID_SUCCESS,
  GET_BOOKING_BY_ID_ERROR,
  SENDING_EMAIL,
  EMAIL_SENT,
  SENDING_EMAIL_ERROR,
  GET_INVOICE_LOADING,
  GET_INVOICE,
  GET_INVOICE_ERROR,
  INQUIRY_LIST_LOADING,
  GET_INQUIRY_LIST,
  GET_INQUIRY_LIST_ERROR,
} from "./types";

const INITIAL_STATE = {
  data: undefined,
  loading: false,
  error: false,
  dataById: undefined,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BOOKING_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_BOOKING_BY_ID_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case SENDING_EMAIL:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_INVOICE_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case INQUIRY_LIST_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case GET_BOOKING_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };
    case GET_BOOKING_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        dataById: action.payload.data,
        error: false,
      };

    case EMAIL_SENT:
      return {
        ...state,
        loading: false,
        dataById: action.payload.data,
        error: false,
      };

    case GET_INVOICE:
      return {
        ...state,
        loading: false,
        dataById: action.payload.data,
        error: false,
      };

    case GET_INQUIRY_LIST:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: false,
      };

    case GET_BOOKING_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };
    case GET_BOOKING_BY_ID_ERROR:
      return {
        ...state,
        dataById: undefined,
        loading: false,
        error: action.payload.data,
      };
    case SENDING_EMAIL_ERROR:
      return {
        ...state,
        dataById: undefined,
        loading: false,
        error: action.payload.data,
      };

    case GET_INVOICE_ERROR:
      return {
        ...state,
        dataById: undefined,
        loading: false,
        error: action.payload.data,
      };

    case GET_INQUIRY_LIST_ERROR:
      return {
        ...state,
        data: undefined,
        loading: false,
        error: action.payload.data,
      };

    default:
      return state;
  }
};

export default reducer;
